export const journeyItemTypeKeys: Record<string, { labelKey: string }> = {
  End: { labelKey: 'journey.type_end' },
  Journey: { labelKey: 'journey.type_journey' },
  Start: { labelKey: 'journey.type_start' },
  Stay: { labelKey: 'journey.type_stay' },
  Stop: { labelKey: 'journey.type_stop' }
};
